<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
      :showButtons="panel.showButtons">
      <div slot="content-main">
        <div>
          <br />
          <SignatureConfig />
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>

import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import SignatureConfig from '../../../components/modules/signature/signature-config/SignatureConfig.vue'

import { mapMutations } from "vuex";

export default {
  name: "SignatureConfigView",
  components: { Panel, SignatureConfig },
  data() {
    return {
      panel: {
        module: "Assinatura Digital",
        title: "Configuração",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  },
};
</script>
